module.exports = __webpack_public_path__ + "static/media/2_en.681a53a0.png";